import { getSportsCollectionPage } from '@/api/market';
import {
  createFeedSourceAdapter,
  resolveFeedPaginationMeta,
} from '@/domain/market/feed-source-adapter.js';

export const SPORT_FEED_PAGE_SIZE = 21;

export function buildSportFeedQuery(store) {
  const sportsSlug = String(store.sportsSlug ?? '').trim();
  return sportsSlug ? { sportsSlug } : {};
}

/**
 * Sport live 列表分页：getSportsCollectionPage → rawRows（collection 原样，卡片映射走 mapFeedCardsForPresentation）
 * @param {object} ctx paginated-feed-core fetchPageResult 上下文
 */
export async function fetchSportFeedPageResult(ctx) {
  const { state, append, pageNum, pageSize = SPORT_FEED_PAGE_SIZE, rawRowsLength } = ctx;
  const sportsSlug = String(state.sportsSlug ?? '').trim();
  const nextPage = append ? pageNum + 1 : 1;
  const data = await getSportsCollectionPage(sportsSlug ? { sportsSlug } : {}, {
    pageNum: nextPage,
    pageSize,
  });
  const apiRows = Array.isArray(data?.rows) ? data.rows : [];
  const { hasMore } = resolveFeedPaginationMeta({
    data,
    rows: apiRows,
    pageSize,
    rawRowsLength: append ? rawRowsLength : 0,
    append,
  });

  return { apiRows, nextPage, hasMore };
}

export function createSportFeedFetchOptions() {
  return createFeedSourceAdapter({
    logTag: 'sportFeed',
    pageSize: SPORT_FEED_PAGE_SIZE,
    buildQuery: buildSportFeedQuery,
    fetchPageResult: fetchSportFeedPageResult,
  });
}
